export default __webpack_public_path__ + "static/media/Mahabalipuram04.f1129d8f.jpg";